<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Operasional Kas</h5>
            </template>

            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="6">
                        <b-form-group label="Tanggal">
                            <b-form-input
                                v-model="filters.tanggal"
                                type="date"
                                name="operasionalKasTanggalFilter"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="align-items-center justify-content-between">
                    <b-col md="6" class="mb-2 mb-md-0">
                        <div class="filter-btn-wrapper d-flex gap-2 flex-wrap" style="margin-left: 0;">
                            <b-button
                                variant="pgiBtn"
                                name="operasionalKasSearchBtn"
                                @click="onFilter"
                            >
                                Search
                            </b-button>
                            <b-button
                                variant="pgiBtn"
                                name="operasionalKasResetBtn"
                                @click="onReset"
                            >
                                Reset
                            </b-button>
                        </div>
                    </b-col>
                    <b-col md="6" class="text-md-right">
                        <div class="d-flex gap-2 flex-wrap justify-content-md-end">
                            <b-button
                                variant="pgiBtn"
                                name="operasionalKasMutasiBtn"
                                @click="onMutasi"
                            >
                                Mutasi
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-table
                bordered
                hover
                show-empty
                responsive
                class="mb-3"
                :busy="isBusy"
                :items="items"
                :fields="fields"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data operasional kas.
                </template>
                <template v-slot:cell(createdAt)="row">
                    <div>{{ $helper.changeDateFormat(row.item.createdAt) }}</div>
                    <div class="smallText text-muted">{{ $helper.changeDateFormatGetHour(row.item.createdAt) }}</div>
                </template>
                <template v-slot:cell(fromType)="row">
                    <div>{{ getTypeName(row.item.fromType) }}</div>
                    <div class="smallText text-muted">{{ row.item.dariCabangName }}</div>
                </template>
                <template v-slot:cell(toType)="row">
                    <div>{{ getTypeName(row.item.toType) }}</div>
                    <div class="smallText text-muted">{{ row.item.tujuanCabangName }}</div>
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no-wrap">Rp. {{ $helper.addThousandSeparator(row.item.nominal) }}</div>
                </template>
                <template v-slot:cell(createdBy)="row">
                    {{ row.item.createdByName }}
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination
                    class="mb-0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @input="onPageChange"
                />
            </div>
        </b-card>

        <ModalInputOperasionalKas
            modal-id="modal-mutasi-kas"
            modal-title="Mutasi Kas"
            submit-label="Mutasi"
            :options-cabang="[]"
            :show-cabang="false"
            :show-from-type="true"
            :show-to-type="true"
            :from-type-options="mutasiTypeOptions"
            :to-type-options="mutasiTypeOptions"
            :enforce-different-type="true"
            :is-submitting="isSubmittingMutasiKas"
            @submit="submitMutasiKas"
        />

        <ModalConfirm
            id="modal-confirm-submit-operasional-kas"
            :title="confirmSubmitTitle"
            :isSubmitting="isCurrentSubmitting"
            :desc="confirmSubmitDesc"
            @submit="confirmSubmitOperasionalKas"
        />
    </div>
</template>

<script>
import ModalInputOperasionalKas from "@/components/modals/ModalInputOperasionalKas.vue";
import { ENUM_TYPE, OPTIONS_TYPE } from "@/constants/operasionalKas";
import CONSTANTS from "@/constants";

export default {
    name: "operasional-kas",
    components: {
        ModalInputOperasionalKas,
    },
    data() {
        const mutasiTypeOptions = OPTIONS_TYPE.filter((item) => {
            return Number(item.value) === ENUM_TYPE.LACI.id || Number(item.value) === ENUM_TYPE.BRANKAS.id;
        });

        return {
            ENUM_TYPE,
            initStatus: 0,
            isBusy: false,
            filters: {
                tanggal: "",
            },
            fields: [
                { key: "createdAt", label: "Tanggal" },
                { key: "fromType", label: "Dari" },
                { key: "toType", label: "Tujuan" },
                { key: "nominal", label: "Nominal" },
                { key: "createdBy", label: "Dibuat Oleh" },
                { key: "keterangan", label: "Keterangan" },
            ],
            mutasiTypeOptions,
            optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
            items: [],
            currentPage: 1,
            show: 10,
            perPage: 10,
            totalRows: 0,
            totalViewText: "",
            isSubmittingMutasiKas: false,
            pendingSubmit: null,
        };
    },
    computed: {
        confirmSubmitTitle() {
            if (this.pendingSubmit == null) return "Konfirmasi";
            return `Confirm ${this.pendingSubmit.actionLabel}`;
        },
        confirmSubmitDesc() {
            if (this.pendingSubmit == null) return "Apakah anda yakin?";
            return `Apakah anda yakin untuk ${this.pendingSubmit.actionLabel.toLowerCase()}?`;
        },
        isCurrentSubmitting() {
            if (this.pendingSubmit == null) return false;
            return this[this.pendingSubmit.submittingKey] || false;
        },
    },
    methods: {
        async init() {
            this.initStatus = 0;
            try {
                this.filters.tanggal = this.getTodayDateValue();
                await this.getItems(1);
                this.initStatus = 1;
            } catch (error) {
                this.$helper.parseError(this, error);
                this.initStatus = -1;
            }
        },
        getTodayDateValue() {
            const date = new Date();
            const month = `${date.getMonth() + 1}`.padStart(2, "0");
            const day = `${date.getDate()}`.padStart(2, "0");
            return `${date.getFullYear()}-${month}-${day}`;
        },
        getTypeName(typeId) {
            if (Number(typeId) === 4) return "Eksternal";
            const found = OPTIONS_TYPE.find((item) => Number(item.value) === Number(typeId));
            return found ? found.text : `${typeId}`;
        },
        buildQueryParams() {
            return {
                cabangId: this.$helper.getCabangId(),
                tanggal: this.filters.tanggal,
                page: this.currentPage - 1,
                size: this.perPage,
            };
        },
        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];
            this.currentPage = isNaN(page) ? 1 : page;

            const params = this.buildQueryParams();
            return this.$axios.get("mutasi-kas-laci-dan-brankas/get-mutasi", { params })
                .then((response) => {
                    const result = response.data || {};
                    const content = Array.isArray(result.content) ? result.content : [];

                    this.items = content.map((item) => ({
                        id: item.id,
                        createdAt: item.createdAt || item.tanggal,
                        fromType: Number(item.fromType),
                        toType: Number(item.toType),
                        nominal: Number(item.nominal || 0),
                        keterangan: item.keterangan || "-",
                        createdByName: item.createdBy || "-",
                        dariCabangName: item.dariCabangName || "-",
                        tujuanCabangName: item.tujuanCabangName || "-",
                    }));

                    this.totalRows = Number(result.totalElements || 0);
                    this.updateTotalViewText();
                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        onFilter() {
            if (this.$helper.isNullOrEmpty(this.filters.tanggal)) {
                this.$helper.toastErr(this, "Tanggal wajib diisi.");
                return;
            }
            this.getItems(1);
        },
        onReset() {
            this.filters.tanggal = this.getTodayDateValue();
            this.getItems(1);
        },
        onLimitChange() {
            this.perPage = this.show;
            this.getItems(1);
        },
        onPageChange(page) {
            this.getItems(page);
        },
        updateTotalViewText() {
            if (this.totalRows === 0) {
                this.totalViewText = "0 dari 0 data";
                return;
            }
            const start = (this.currentPage - 1) * this.perPage + 1;
            const end = Math.min(this.currentPage * this.perPage, this.totalRows);
            this.totalViewText = `${start}-${end} dari ${this.totalRows} data`;
        },
        onMutasi() {
            this.$bvModal.show("modal-mutasi-kas");
        },
        submitMutasiKas(payload) {
            this.openSubmitConfirm({
                payload,
                modalId: "modal-mutasi-kas",
                actionLabel: "Mutasi Kas",
                successText: "Mutasi kas berhasil.",
                submittingKey: "isSubmittingMutasiKas",
            });
        },
        openSubmitConfirm(payloadSubmit) {
            this.pendingSubmit = payloadSubmit;
            this.$bvModal.show("modal-confirm-submit-operasional-kas");
        },
        confirmSubmitOperasionalKas() {
            if (this.pendingSubmit == null) return;
            this.submitOperasionalKas(this.pendingSubmit);
        },
        submitOperasionalKas({ payload, modalId, successText, submittingKey }) {
            this[submittingKey] = true;
            const cabangId = this.$helper.getCabangId();
            const queryParams = new URLSearchParams({
                cabangId: `${cabangId}`,
                fromType: `${Number(payload.fromType)}`,
                toType: `${Number(payload.toType)}`,
                nominal: `${Number(payload.nominal)}`,
                keterangan: `${payload.keterangan || ""}`,
            }).toString();

            this.$axios.post(`mutasi-kas-laci-dan-brankas/?${queryParams}`)
                .then(() => {
                    this.$bvModal.hide("modal-confirm-submit-operasional-kas");
                    this.$bvModal.hide(modalId);
                    this.getItems(this.currentPage);
                    this.$helper.toastSucc(this, successText);
                })
                .catch((error) => {
                    console.log(error);
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this[submittingKey] = false;
                    this.pendingSubmit = null;
                });
        },
    },
    created() {
        this.init();
    },
};
</script>
